<template>
  <section>
    <div class="container is-widescreen">
      <h1 class="title has-text-secondary is-size-4" v-t="'other-projects'"></h1>
      <div class="columns is-multiline is-variable is-1" style="padding-top:15px;">
        <div class="column" v-for="capsule in randomCapsules" :key="capsule._id">
           <library-capsule-card :capsule="capsule" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { _ } from 'underscore'
import { languageManager } from '@/mixins/LanguageManager'
import LibraryCapsuleCard from '@/components/LibraryCapsuleCard'
export default {
  name: 'related-capsules',
  mixins: [languageManager],
  components: { LibraryCapsuleCard },
  mounted () {
    this.fetchCapsules()
  },
  computed: {
    ...mapGetters(['formattedCapsules', 'currentCapsuleId']),
    randomCapsules: function () {
      return _.chain(this.formattedCapsules)
        .shuffle()
        .filter(capsule => capsule._id !== this.currentCapsuleId)
        .sample(3)
        .value()
    }
  },
  methods: {
    ...mapActions(['fetchCapsules'])
  }
}
</script>

<style>
</style>
